import { apiUrl } from "../utils/apiUrl";
import { getAdminToken } from "../admin/sessionSlice";

function jsonHeaders() {
  const adminToken = getAdminToken();
  return {
    "Content-Type": "application/json",
    ...(adminToken ? { Authorization: `Bearer ${adminToken}` } : {}),
  };
}

export async function ensureUnhealthyGame(body) {
  const response = await fetch(apiUrl("/unhealthy-game/ensure"), {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(body),
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(json.error || `ensure failed: ${response.status}`);
  }
  return json;
}

export async function getUnhealthyGameState(params) {
  const q = new URLSearchParams(params);
  const response = await fetch(`${apiUrl("/unhealthy-game/state")}?${q.toString()}`, {
    headers: jsonHeaders(),
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(json.error || `state failed: ${response.status}`);
  }
  return json;
}

export async function completeUnhealthyStage(body) {
  const response = await fetch(apiUrl("/unhealthy-game/complete-stage"), {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(body),
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(json.error || `complete-stage failed: ${response.status}`);
    err.code = json.code;
    err.status = response.status;
    throw err;
  }
  return json;
}

export async function saveUnhealthyGameProgress(body) {
  const response = await fetch(apiUrl("/unhealthy-game/progress"), {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(body),
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(json.error || `progress failed: ${response.status}`);
  }
  return json;
}
